import { API } from '../services/API';
import {
	GET_INSPECTIONAPPLICATIONS_PATH,
	GET_INSPECTIONAPPLICATION_DETAIL_PATH,
	CREATE_INSPECTIONAPPLICATIONS_PATH
	
} from '../services/paths';
import {
   GET_INSPECTIONAPPLICATIONS, GET_INSPECTIONAPPLICATION_DETAIL, CREATE_INSPECTIONAPPLICATIONS
} from './types';
import { showMessage } from '../utils/messageUtils';
import { ERROR , SUCCESS} from '../utils/constants';

const getInspectionApplications = ( params = {} ) => ( dispatch ) => dispatch( {
	type: GET_INSPECTIONAPPLICATIONS,
	promise: API.get( GET_INSPECTIONAPPLICATIONS_PATH, { params } ),
	meta: {
		onFailure: ( error ) => showMessage( { type: ERROR, msg: error?.response?.data?.message } )
	}
} );
const getInspectionApplicationsDetail = ( params = {} ) => ( dispatch ) => dispatch( {
	type: GET_INSPECTIONAPPLICATION_DETAIL,
	promise: API.get( GET_INSPECTIONAPPLICATION_DETAIL_PATH, { params } ),
	meta: {
		onFailure: ( error ) => showMessage( { type: ERROR, msg: error?.response?.data?.message } )
	}
} );

const createInspectionApplicationsPath = CREATE_INSPECTIONAPPLICATIONS_PATH;

const createInspectionApplications = ( form, callback = () => {} ) => ( dispatch ) => dispatch( {
	type: CREATE_INSPECTIONAPPLICATIONS,
	promise: API.post( CREATE_INSPECTIONAPPLICATIONS_PATH, form),
	meta: {
		onSuccess: ( res ) => {
			callback();
			showMessage( { type: SUCCESS, msg: res?.data.message } );
		},
		onFailure: ( error ) => showMessage( { type: ERROR, msg: error?.response?.data?.message } )
	}
} );

export {
	getInspectionApplications,
	getInspectionApplicationsDetail,
	createInspectionApplications,
	createInspectionApplicationsPath
};
